import { useEffect, useRef } from 'react';

export const useIsFirstRender = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};
